import { GetterTree } from 'vuex'

import { CheckInState } from './types'
import { RootState } from '../types'
import { Condition, OfferItem } from '@/types'

export const getters: GetterTree<CheckInState, RootState> = {
  getOfferInformation(state): any {
    return state.offerInformation
  },
  getCheckedInOfferItems(state): OfferItem[] {
    return state.checkedInOfferItems
  },
  getOfferItem(state): OfferItem | null {
    return state.offerItem
  },
  getSelectedCondition(state): Condition | null {
    return state.selectedCondition
  },
}
